import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Actions, TableColumn } from '@app/shared/table/TableColumn';

import { AddAdminComponent } from '@app-admin/dialogs/add-admin/add-admin.component';
import { DialogService } from '@app-admin/dialogs/dialog.service';
import { UtilService } from '@app-shared/services/util.service';
import { DeleteService } from '@app/shared/table/delete.service';
import { GetAllService } from '@app/shared/table/getAll.service';
import { UpdateStatusService } from '@app/shared/table/updateStatus.service';

declare var $: any;
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-manage-system-admins',
    templateUrl: './manage-system-admins.component.html',
    standalone: false
})
export class ManageSystemAdminsComponent implements OnInit {

   @HostListener('document:click', ['$event'])
    closeMenus(event: MouseEvent) {
      const target = event.target as HTMLElement;
      const insideMenu = target.closest('.mat-menu-panel');
      const menuBtn = target.closest('[mat-menu-trigger-for]') || 
                      target.closest('button[mat-icon-button]');
      if (!insideMenu && !menuBtn) {
        document.querySelectorAll('.mat-menu-panel').forEach(menu => {
          (menu as HTMLElement).style.display = 'none';
        });
      }
    }

  displayedColumns: string[] = ['sno', 'name', 'email', 'phone', 'designation', 'location', 'is_active', 'action'];
  dataSource: MatTableDataSource<any>;
  UserId: any = parseInt(localStorage.getItem('superUserId'));
  isOrgSuperAdmin: boolean = JSON.parse(localStorage.getItem('isOrgSuperAdmin'));
  isSuperAdmin: boolean;
  serviceError: string;
  isLoading = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private srvc: DialogService,
    private util: UtilService,
    private dialog: MatDialog,
    private route: Router,
    private cdr: ChangeDetectorRef,
    private deleteService: DeleteService,
    private updateStatusService: UpdateStatusService,
    private getAllService: GetAllService
  ) {
    // Ensure dialog always works for system super admins when no data passed
    if (this.data === undefined || this.data === null) {
      this.data = -1;
    }
  }

  tableColumns: Array<TableColumn> = [
    { name: 'S.No.', dataKey: 'sno', type: 'text', isSortable: true },
    { name: 'Name', dataKey: 'name', type: 'text', isSortable: true },
    { name: 'Email', dataKey: 'email', type: 'text', isSortable: true },
    { name: 'Phone', dataKey: 'phone', type: 'text', isSortable: true },
    { name: 'Designation', dataKey: 'designation', type: 'text', isSortable: true },
    { name: 'Location', dataKey: 'location', type: 'text', isSortable: true },
    { name: 'Status', dataKey: 'is_active', type: 'toogle', isSortable: false,  isFilterable: true,
    conditionalNaming: {
        true: {
          name: 'Active',
          checked: true,
        },
        false: {
          name: 'Inactive',
          checked: false,
        },
      },
     },
    // Org Super Admin column will be conditionally added in ngOnInit
    {
      name: 'Actions',
      type: 'threeDotActions',
      rowActions: [
        { iconName: 'edit', iconTooltip: 'Modify Admin', name: 'edit' },
        { iconName: 'history', iconTooltip: 'Show Revision History', name: 'history' },
        { iconName: 'trash', iconTooltip: 'Delete Admin', name: 'delete' }
      ]
    }
  ];

    filterAttributes = [
    {
      dataKeyName: 'name',
      name: 'Name',
      type: 'text'
    },
    {
      dataKeyName: 'status',
      name: 'Status',
      type: 'status',
      data: ['Active', 'Inactive'],
    },
    {
      dataKeyName: 'all',
      name: 'All Text',
      type: 'all',
      data: ['Name', 'Email', 'Phone', 'Designation', 'Location'],
    },
  ];

  tableActions: Array<Actions> = [
    { iconName: 'plus', iconTooltip: 'Add Admin', name: 'add' }
  ];

    rowAction(event: any) {
    switch (event.rowName) {
      case 'edit':
        this.modifyAdmin(event.row.id);
        break;
      case 'history':
        this.showRevisionHistory(event.row);
        break;
      case 'delete':
        this.deleteAdmin(event.row.id);
        break;
      default:
        break;
    }
  }

  tableActionEmitter(event: any) {
    if (event === 'add') {
      this.addAdminPopup();
    }
  }

  ngOnInit(): void {
    this.isSuperAdmin = this.util.decrypt(localStorage.getItem('ur')) === 'SA';
    this.dataSource = new MatTableDataSource([]);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.getAllAdmins();
  }

  onToggleChange(event: { row: any, checked: boolean, column: string }) {
    console.log('Toggle Change Event:', event);
  if (event.column === 'is_active') {
    this.updateStatus(event, event.row.id);
  }
}

  getAllAdmins() {
    // Force organization id -1 for system super admins
    const requestData = -1;
    this.getAllService.getAdmin(requestData).subscribe(
      (data: any) => {
         this.isLoading = false; 
        data.body.responseBody.sort((a, b) => a.id - b.id);
        const tableData = data.body.responseBody.map((i, index) => {
          i.sno = index + 1;
          i.name = i.full_name;
          i.location = `${i.district_name}, ${i.state_name}`;
          delete i['full_name'];
          return i;
        });
        if (tableData && tableData.length) {
          const loginAdminIndex = tableData.findIndex((ele) => ele.id === this.UserId);
          if (loginAdminIndex !== -1) {
            tableData.splice(loginAdminIndex, 1);
          }
        }
        this.dataSource.data = tableData;
        this.dataSource._updateChangeSubscription();
        this.cdr.markForCheck();
      },
      (err: any) => {
        this.util.errorNotification(err);
        this.isLoading = false;
        this.cdr.markForCheck();
      }
    );
  }

  addAdminPopup(data?: any) {
    this.dialog.closeAll();
    // For system super admin creation, fetch default role & category for org -1
    let param = { 
      orgId: -1,
      role_name: 'Admin',
      category_name: 'Org Super Admin'
     };
    const orgId = -1;
    // Fetch roles first
    this.getAllService.getAdminRolesByOrg(param).subscribe(
      (rolesRes: any) => {
  const roles = rolesRes?.body?.responseBody || [];
  // Prefer role with name 'Full Access' for system super admins (case-insensitive), fallback to first
  const foundRole = roles.find((r: any) => (r.role_name || '').toLowerCase() === 'full access') || roles[0];
  const defaultRoleId = foundRole ? foundRole.id : null;
        // Fetch user categories
        this.getAllService.getUserCategoriesByOrg(param).subscribe(
          (catsRes: any) => {
            const cats = catsRes?.body?.responseBody || [];
            // Prefer category 'Org Super Admin' (case-insensitive), fallback to first
            const foundCat = cats.find((c: any) => (c.category_name || '').toLowerCase() === 'org super admin') || cats[0];
            const defaultCategoryId = foundCat ? foundCat.id : null;
            const dialogData = data || { orgId, user_role_id: defaultRoleId, user_category_id: defaultCategoryId };
            const dialogRef = this.dialog.open(AddAdminComponent, {
              width: 'min(1000px, 92vw)',
              autoFocus: false,
              panelClass: ['no-shadow-dialog'],
              backdropClass: 'no-shadow-dialog-backdrop',
              data: dialogData
            });
            dialogRef.afterClosed().subscribe(result => {
              this.dialog.open(ManageSystemAdminsComponent, {
                width: 'min(1000px, 92vw)',
                data: -1,
                autoFocus: false,
              });
            });
          },
          (errCats: any) => {
            // failed to fetch categories — open dialog with role if available
            const dialogData = data || { orgId, user_role_id: defaultRoleId };
            const dialogRef = this.dialog.open(AddAdminComponent, {
              width: 'min(1000px, 92vw)',
              autoFocus: false,
              panelClass: ['no-shadow-dialog'],
              backdropClass: 'no-shadow-dialog-backdrop',
              data: dialogData
            });
            dialogRef.afterClosed().subscribe(result => {
              this.dialog.open(ManageSystemAdminsComponent, {
                width: 'min(1000px, 92vw)',
                data: -1,
                autoFocus: false,
              });
            });
          }
        );
      },
      (errRoles: any) => {
        // failed to fetch roles — open dialog without defaults
        const dialogRef = this.dialog.open(AddAdminComponent, {
          width: 'min(1000px, 92vw)',
          autoFocus: false,
          panelClass: ['no-shadow-dialog'],
          backdropClass: 'no-shadow-dialog-backdrop',
          data: data || { orgId }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.dialog.open(ManageSystemAdminsComponent, {
            width: 'min(1000px, 92vw)',
            data: -1,
            autoFocus: false,
          });
        });
      }
    );
  }

  modifyAdmin(id) {
    this.srvc.getAdminById(parseInt(id)).subscribe(
      (data: any) => {
        this.addAdminPopup(data.body.responseBody);
      },
      (err: any) => {
        this.util.errorNotification(err);
        this.cdr.markForCheck();
      }
    );
  }

showRevisionHistory(row: any) {
  this.dialog.closeAll();
  
  try {
    // For system-level, organization id is -1 
    // Store the org ID in localStorage so the resolver can pick it up
    localStorage.setItem('SelectedOrgId', '-1');
    localStorage.setItem('OrgIdForRevision', this.util.encrypt('-1'));
    
    this.route.navigate(
        ['/admin/system-admin/RevisionHistory', row.id, row.name],
      { queryParams: { orgId: -1 } }
    ).catch(err => {
      console.error('Navigation failed:', err);
      this.util.simpleDialog({
        title: 'Error',
        message: 'Could not open revision history'
      });
    });

  } catch (error) {
    console.error('Error showing revision history:', error);
    this.util.simpleDialog({
      title: 'Error',
      message: 'Failed to load organization information'
    });
  }
}

  updateStatus(event, id: number) {
    this.updateStatusService.updateStatus(event, id, false, 'adminStatus').subscribe((data: any) => {
      const responseHead = data.body.responseHead;
      const successMsg = responseHead ? this.util.getSuccessMessage('UPDATE_ADMIN_STATUS', responseHead.statusCode, responseHead.statusDesc) : responseHead;
      this.util.simpleDialog({
        title: 'Updated',
        message: successMsg,
      });
      this.getAllAdmins();
      this.util.showLoader = false;
    }, (err) => {
      this.util.showLoader = false;
      this.serviceError = err.responseHead
        ? this.util.getIntlErrorMessage("MANAGE_ADMINS", err.responseHead.statusCode, err.responseHead.statusDesc)
        : err;
      this.util.simpleDialog({
        title: 'Error',
        message: this.serviceError,
      });
    });
  }

  updateOrgAdmin(event, id: number) {
    this.updateStatusService.updateStatus(event, id, false, 'updateOrgAdmin').subscribe((res: any) => {
      const responseHead = res.body.responseHead;
      const successMsg = responseHead ? this.util.getSuccessMessage('UPDATE_ADMIN_ROLE', responseHead.statusCode, responseHead.statusDesc) : responseHead;
      this.util.simpleDialog({
        title: 'Updated',
        message: successMsg,
      });
      this.util.showLoader = false;
    }, (err) => {
      this.util.showLoader = false;
      this.serviceError = err.responseHead
        ? this.util.getIntlErrorMessage("MANAGE_ADMINS", err.responseHead.statusCode, err.responseHead.statusDesc)
        : err;
      this.util.simpleDialog({
        title: 'Error',
        message: this.serviceError,
      });
    });
  }

  deleteAdmin(id: number) {
    const postData = {
      impactedRowId: id,
    };
    this.deleteService.delete(postData, 'deleteAdmin').subscribe((data: any) => {
      const responseHead = data.body.responseHead;
      const successMsg = responseHead ? this.util.getSuccessMessage('DELETE_ADMIN', responseHead.statusCode, responseHead.statusDesc) : responseHead;
      this.util.simpleDialog({
        title: 'Deleted',
        message: successMsg,
      });
      this.getAllAdmins();
      this.util.showLoader = false;
    }, (err) => {
      this.util.showLoader = false;
      this.serviceError = err.responseHead
        ? this.util.getIntlErrorMessage("MANAGE_ADMINS", err.responseHead.statusCode, err.responseHead.statusDesc)
        : err;
      this.util.simpleDialog({
        title: 'Error',
        message: this.serviceError,
      });
    });
  }

}

